// extracted by mini-css-extract-plugin
export var copyableItem = "_f-0";
export var underlined = "_f-1";